import { useState, useEffect } from 'react';
import { DownloadSimple, X } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show banner if not dismissed before
      const dismissed = localStorage.getItem('pwa-dismissed');
      if (!dismissed) setShowBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setShowBanner(false);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa-dismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 z-50 animate-slide-up" data-testid="pwa-install-banner">
      <div className="bg-[#111115] border border-white/10 rounded-md p-4 shadow-xl shadow-black/50">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-md bg-[#FF6B1A]/10 flex items-center justify-center shrink-0">
            <DownloadSimple size={22} weight="duotone" className="text-[#FF6B1A]" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-heading font-bold text-sm uppercase tracking-tight text-white">INSTALL PARLAY POSSE</p>
            <p className="text-xs text-white/40 mt-0.5">Add to your home screen for the best experience</p>
          </div>
          <button onClick={handleDismiss} className="text-white/30 hover:text-white p-1" data-testid="pwa-dismiss">
            <X size={16} />
          </button>
        </div>
        <Button
          onClick={handleInstall}
          className="w-full mt-3 bg-[#FF6B1A] hover:bg-[#FF853E] text-white font-heading font-bold uppercase tracking-wide text-xs py-2"
          data-testid="pwa-install-btn"
        >
          <DownloadSimple size={16} className="mr-2" />
          INSTALL APP
        </Button>
      </div>
    </div>
  );
}
